import Translation from "../common/types/translation.type";

function createTranslation<T extends Translation<Record<string, string>>>(translation: T): T {
    return translation;
}

export default createTranslation;